import _taggedTemplateLiteral from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  query($order: [RefundsFindOrder!],$where: RefundsFindFilter) {\n    exportRefundsList(\n      order: $order,\n      where: $where\n    ) {\n      fileName\n      contentB64\n    }\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  mutation($orderId:Int!){\n    cancelRefund(orderId:$orderId)\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  mutation($description: String , $orderId: Int! , $refundWay:RefundWay!) {\n    createRefund(\n      description: $description,\n      orderId: $orderId \n      refundWay: $refundWay\n    )\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  query($order: [RefundsFindOrder!],$paging: PagingQuery,$where: RefundsFindFilter) {\n    findRefunds(\n      order: $order,\n      paging: $paging,\n      where: $where\n    ) {\n      refunds {\n        account\n        channel\n        createdAt\n        description\n        id\n        indexNumber\n        refundWay\n        auditStatus\n        order {\n          id\n          transactionNumber\n          orderNumber\n          period\n          dealer {\n            realname\n            storePhone\n          }\n          address {\n            phone\n            realname\n            className\n            year\n            school {\n              name\n            }\n          }\n        }\n        orderId\n        queryTriedTimes\n        recvAccount\n        refundNumber\n        status\n        successTime\n        totalAmount\n        totalPrice\n        transactionNumber\n        type\n        updatedAt\n      }\n      paging {\n        currentOffset\n        take\n        totalCount\n      }\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import gql from 'graphql-tag';
export var findRefunds = gql(_templateObject());
export var createRefund = gql(_templateObject2());
export var cancelRefund = gql(_templateObject3());
export var exportRefundsList = gql(_templateObject4());